module.exports = __webpack_public_path__ + "static/img/7.fb00d11a.png";